import { useState, useEffect } from "react";
import "./styles/PanelPortafolio.css";
import Search from "../generales/Search";
import Action from "../Action";
import Modal from "react-modal";
import LoadSimple from "../LoadSimple";
import ModalCreateTech from "./ModalCreateTech";
import TablePortafolioServices from "./TablePortafolioServices";
import InfoPortafolio from "./InfoPortafolio";
import Paginador from "../generales/Paginador";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import TablePortafolioDevices from "./TablePortafolioDevices";
import ModalCreateTechDevice from "./ModalCreateTechDevice";
const CreateCisModalStyles = {  
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "35%",
    height: "95%",
    padding: "20px",
  },
};
const PanelPortafolioDevices = ({ server,
  ServiceSelected,
  setServiceSelected,
  tecSelected,
  setTecSelected,
       slaService,
         setSlaService,
         slaTech,
         setSlaTech,
  languaje,
  handleShowPopup,
  mode
  }) => {
  
  
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  
 
  

  const [listSelected, setListSelected] = useState(1);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [dataObject, setDataObject] = useState({
    data: [],
    loading: true,
    error: null,
  })
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 
  var dataList = searchTerm === "" ? (dataUsers.data.length!=0?dataUsers.data.devices:[]) : searchResults;
 
  const [searchResult, setSearchResult] = useState(null);
  const [limitList, setLimitList] = useState(50); 
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [CreateServiceModalOpen, setCreateServiceModalOpen] = useState(false);
  const pages = parseInt(dataList.length / limitList) + 1;

  const handleSelectChange = (e) => {
    setLimitList(e.target.value);setPageActual(1);
  };

  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
 
  const [editActive, setEditActive] = useState(false);
  const [dataService, setDataService] = useState([]);
  
  const [loadCatalogo,setLoadCatalogo]=useState(false)
  const [loadPlantilla,setLoadPlantilla]=useState(false)
  const [sla,setSla]=useState(tecSelected.sla)
  // const [slaTech,setSlaTech]=useState(0)



  const hadleChangeList = (e) => {
    setListSelected(e);
  };
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
 
  const crear = () => {
    setCreateServiceModalOpen(true);
  };

  
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  
 
  
  useEffect(() => {
    // search_services();
    setSlaTech(tecSelected.sla)
  }, []);
  
  const regresar_cis = () => {
    setTecSelected([]);
    // setLoadingCis(true)
  };

 
  function closCreateServiceModal() {
    setEditActive(false);
    setCreateServiceModalOpen(false);
  }
  const handleChangEdit = (element) => {
   
    setEditActive(true);
   
    setDataService(element);
          setCreateServiceModalOpen(true);
  };
  const token_item=localStorage.getItem('access_token')

  const [dataCisConf, setDataCisConf] = useState({
    data: [],
    loading: true,
    error: null,
  });
  useEffect(() => {
    search_devices();
  }, []);
  
  const search_devices = () => {
    // setLoadingCis(true)
   
    setDataCisConf({
      data: dataCisConf.data,
      loading: true,
      error: dataCisConf.error,
    });
    const fetchDataPost = async () => {
      try {
        
        const response = await fetch(
          server.url +
            "/api/v1/cassia/services/techs/devices/" +
            tecSelected.cassia_tech_id,//cambiar por el id de tecnologia
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        
        if (response.ok) {
          const data1 = await response.json();
          // setLoadingCis(false)

         
          setDataCisConf({
            data: data1,
            loading: false,
            error: dataCisConf.error,
          });
         
          setSlaTech(data1.data.sla_tech)
          setSla(data1.data.sla_service)
          setPageActual(1);

          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
        
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        
      }
    };

    fetchDataPost();
  };
  return (
    <>
    <div className="head-cis">
        <div className="title-cis">
          <Search
                    searchResults={searchResults}
                    setSearchResults={setSearchResults}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                    onSearch={handleSearch}
                    dataObject={dataObject.data.devices}
                    setDataObject={setDataObject}
                    searchResult={searchResult}
                    setSearchResult={setSearchResult}
                    languaje={languaje}
                  />
          <div className={"cont-result-registers"+mode}>
          
                  <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                      dataList.length +
                      ") " 
                      }
                  </p> 
          </div>
          <div className="cont-buttons-panel">
                  
                    <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ "+capitalizeFirstLetter(lang[languaje]['nuevosDispositivos'])}
                    action={crear}
                  />
                  
                 
                </div>
        </div>
      </div>
      <div className="cont-cis">
      <div className="main-panel-portafolio">
        <div className="compact-content-portafolio">
        <div className={"content-portafolio-head"+mode}>
        {ServiceSelected.length === 0 ? '':
            <>
                <div
                  className="cont-btn-back-users"
                  style={{ width: "10%" }}
                  onClick={regresar_cis}
                >
                  <div className="cont-img-back-users">
                    <img
                      className="img-back-users"
                      src={(mode=='')?"/iconos/back.png":"/iconos/back-blanco.png"}
                      name="regresar"
                    />
                  </div>
                  <div className="cont-txt-back-users">
                    <div className={"txt-back-users"+mode}>{capitalizeFirstLetter(lang[languaje]['regresar'])}</div>
                  </div>
                </div>
                <div className={"txt-back-users"+mode+" sla-content"} style={{width: '30%',left:'0%'}}>{ServiceSelected.service_name }&nbsp;&nbsp;&nbsp;&nbsp;{ '     SLA: '+slaService+"%"}</div> <div className={"arrow-service"+mode} >{'--->>'}</div>
                <div className={"txt-back-users"+mode+" sla-content"}  style={{width: '30%',left:'0%'}}>{tecSelected.tech_name }&nbsp;&nbsp;&nbsp;&nbsp;{ '     SLA: '+slaTech+"%"}</div>
              </>
  }
        
                </div>
        <div className={"content-portafolio"+mode}>
          

          <div className="cont-portafolio-table">
            <div className="content-card-portafolio" id="content">
              { (
                <>
                  {/* {ServiceSelected.length === 0 ? ( */}
                    <TablePortafolioDevices
                      pageActual={pageActual}
                       limitList={limitList} startLimit={startLimit}
                      dataList={dataList}
                      ServiceSelected={ServiceSelected}
                      setServiceSelected={setServiceSelected}
                      registerIsValid={registerIsValid}
                      searchResults={searchResults}
                      setSearchResults={setSearchResults}
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      dataUsers={dataUsers}
                      setDataUsers={setDataUsers}
                      server={server}
                      setRegisterIsValid={setRegisterIsValid}
                      setData={setData}
                      setLoading={setLoading}
                      setError={setError}
                      devices={devices}
                      setDataService={setDataService}
                      dataService={dataService}
                      handleChangEdit={handleChangEdit}
                      sla={sla}
                      setSla={setSla}
                      tecSelected={tecSelected}
       setTecSelected={setTecSelected}
       slaService={slaService}
         setSlaService={setSlaService}
                      languaje={languaje}
                      dataObject={dataObject}
                      setDataObject={setDataObject}
                      slaTech={slaTech}
         setSlaTech={setSlaTech}
                      dataCisConf={dataCisConf}
                      mode={mode}
                      handleShowPopup={handleShowPopup}
                    ></TablePortafolioDevices>
                  
                </>
              )}
            </div>
          </div>
        </div>
        <div className={"content-portafolio-footer"+mode}>
        <div className="cont-display-paginador">
<Paginador  pages={pages}
                    pageActual={pageActual}
                    setPageActual={setPageActual}
                    mode={mode}></Paginador>
        </div>
        <div className="cont-display-paginador">
              <div className={"cont-half-display-paginador"+mode}>
              <div>
                          <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                          <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                            <option value={10}>10</option>
                            <option value={50} >50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                          </select>
                      </div>
          
              </div>
              <div className={"cont-half-display-paginador"+mode}>
              <p style={{  textAlign: "center" }}>
                    &nbsp;
                    {"(" +
                      (startLimit + 1) +
                      " - " +
                      (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                        ?  parseInt(pageActual ) * parseInt(limitList)
                        : dataList.length) +
                      ")  "+lang[languaje]['de']+" " +
                      dataList.length +
                      " "+lang[languaje]['resultados']}
                  </p>
              </div>
        </div>
        
        </div>
        </div>
      </div>
      </div>
      <Modal
    isOpen={CreateServiceModalOpen}
    // isOpen={false}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closCreateServiceModal}
    style={CreateCisModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
       
    <ModalCreateTechDevice mode={mode} languaje={languaje} server={server} dataCisConf={dataUsers} search_devices={search_devices} tecSelected={tecSelected} closCreateTechModal ={closCreateServiceModal }/>
    </Modal>
    </>
  );
};

export default PanelPortafolioDevices;
